// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3R1xi","Rematch":"Button_Rematch__34Ns3","Endgame":"Button_Endgame__51toF"};